<template>
  <v-main ref="content" class="pt-0">
    <v-container fluid>
      <div class="layout h-100">
        <template v-for="instance in abapInstances">
          <!-- 바로 아래 라인과 같이 하면 "Duplicate keys detected" 에러가 발생한다.2021.12.27.KWShin -->
          <!--abap :instance="instance" :key="instance.id" /-->
          <abap :instance="instance" :key="instance.destNm" :userTypeColors="userTypeColors" :wpStatusColors="wpStatusColors" :wpTypeColors="wpTypeColors" />
        </template>
        <template v-for="instance in javaInstances">
          <template v-for="node in instance.nodes">
            <!-- 바로 아래 라인과 같이 하면 "Duplicate keys detected" 에러가 발생한다.2025.11.20.KWShin -->
            <!--java :node="node" :key="node.id" /-->
            <java :node="node" :key="node.instanceId + node.id" />
          </template>
        </template>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from 'vuex';
import { api } from '@/api/common/instances';
import { isEmpty } from 'lodash';
import Abap from './abap';
import Java from './java';

export default {
  components: {
    Abap,
    Java,
  },
  data() {
    return {
      // BEGIN::Added.by.KWShin.2024.02.14.
      userTypeColors: '',
      wpStatusColors: '',
      wpTypeColors: '',
      // FINISH::Added.by.KWShin.2024.02.14.
    };
  },
  computed: {
    ...mapGetters('common/system', ['getSystemsByStack']),
    abapInstances() {
      return (this.getSystemsByStack('ABAP') || []).reduce((instances, system) => instances.concat(system.abapInstances), []);
    },
    javaInstances() {
      return (this.getSystemsByStack('JAVA') || []).reduce((instances, system) => instances.concat(system.javaInstances), []);
    },
  },
  async created() {
    // WebSocket에 대한 connect()를 api 호출보다 반드시 먼저해야 한다.
    // api를 호출하는 것을 waiting하는 동안 자식 컴포넌트들이 생성되어 달라붙어
    // WebSocket을 사용하려 하는데 WebSocket.connect()가 되어 있지 않으므로
    // 자식 컴포넌트들이 WebSocket에서 데이터를 읽어가지 못하게 된다.
    // 절대 뒤로 옮기지 마라.2024.02.14.KWShin.
    this.$websocket.realtime.connect();

    // BEGIN::Added.by.KWShin.2024.01.11
    // Pie 차트의 색상이 하드코딩 되어 있던 걸,
    // CONF_USER_MTL에서 설정을 읽어와서 적용하도록 기능 추가.
    let apiUrl = '/prefer/users/admin/motlet-properties';
    let motletId = 'preference/chart-color/user-type/color';
    let rspn = await api.get(`${apiUrl}?motletId=${motletId}`);
    if (!isEmpty(rspn.data.motletProperties)) this.userTypeColors = rspn.data.motletProperties;
    // FINISH::Added.by.KWShin.2024.01.11

    // BEGIN::Added.by.KWShin.2024.01.11
    // Pie 차트의 색상이 하드코딩 되어 있던 걸,
    // CONF_USER_MTL에서 설정을 읽어와서 적용하도록 기능 추가.
    motletId = 'preference/chart-color/wp-status/color';
    rspn = await api.get(`${apiUrl}?motletId=${motletId}`);
    if (!isEmpty(rspn.data.motletProperties)) this.wpStatusColors = rspn.data.motletProperties;

    motletId = 'preference/chart-color/wp-type/color';
    rspn = await api.get(`${apiUrl}?motletId=${motletId}`);
    if (!isEmpty(rspn.data.motletProperties)) this.wpTypeColors = rspn.data.motletProperties;
    // FINISH::Added.by.KWShin.2024.01.11
  },
  // BEGIN::Added.by.KWShin.2023.12.09.
  // 뭐야... 여태 wobsock이 close가 안돼고 있었던 거야???
  beforeDestroy() {
    this.$websocket.realtime.close();
  },
  // FINISH::Added.by.KWShin.2023.12.09.
};
</script>
